/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_SignupInputs */



/**
* | output |
* | --- |
* | "Sign up" |
*
* @param {Landing_SignupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const landing_signup = /** @type {((inputs?: Landing_SignupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_SignupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscription")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrarse")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cadastrar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrati")
	return /** @type {LocalizedString} */ ("Sign up")
});